import React from 'react';

import * as S from './Radiobtn.styles';

const RadioBtn = ({
  id,
  inputName,
  radioClicker,
  variant = 'CHECK',
  isChecked,
  customClass = '',
  element,
}) => {
  const {order, key} = element || {};

  const renderRadioElement = item => {
    const {component, data} = item || {};
    switch (component) {
      case 'TEXT':
        return <span className="marginRight12">{data?.primaryText}</span>;
    }
  };

  return (
    <S.wrappper>
      {variant === 'CHECK' ? (
        <span className={`customRadiobtn check ${customClass}`}>
          <input
            id={id}
            type="radio"
            name={inputName}
            onChange={radioClicker}
            checked={isChecked}
          />
          <b>&nbsp;</b>
        </span>
      ) : (
        <span className={`customRadiobtn dot ${customClass} marginRight12 customRadio`}>
          {order?.length &&
            order?.map((item, idx) => {
              return <>{renderRadioElement(element[item])}</>;
            })}
          <input
            id={id}
            type="radio"
            name={inputName}
            onChange={radioClicker}
            checked={isChecked}
            value={key}
          />
          {/* <b>&nbsp;</b> */}
        </span>
      )}
    </S.wrappper>
  );
};

export default RadioBtn;
